export default __webpack_public_path__ + "static/media/BR - MS Cloud App Security.bd32b8fd.png";